<template>
	<c-dialog ref="dialog" title="采购单详情" mode="slide" width="100vw-300" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="detailData.purchase_code" class="m-detail-tag flex-center-cross">
				<label>{{detailData.purchase_code}}</label>
			</div>
		</template>
		
		<module>
			<module-col size="350">
				<c-detail class="m-detail-form">
					<c-detail-item label="采购员">
						{{detailData.purchase_user_realname}}
					</c-detail-item>
					<c-detail-item label="采购日期">
						{{detailData.purchase_date}}
					</c-detail-item>
					<c-detail-item label="采购数量">
						{{detailData.purchase_count}}
					</c-detail-item>
					<c-detail-item label="供应商">
						{{detailData.supplier_name}}
					</c-detail-item>
					<c-detail-item label="预计交期">
						{{detailData.plan_delivery_date}}
					</c-detail-item>
					<c-detail-item label="入库数量">
						{{detailData.storage_count}}
					</c-detail-item>
					<c-detail-item label="退货数量">
						{{detailData.return_count}}
					</c-detail-item>
					<c-detail-item label="创建人">
						{{detailData.create_user_realname}}
					</c-detail-item>
					<c-detail-item label="创建时间">
						{{detailData.create_date}}
					</c-detail-item>
					<custom-detail work-type="39" :data="detailData.customFieldValues"></custom-detail>
				</c-detail>
			</module-col>

			<module-col tab-type="border-tab">
				<module-tab name="产品明细" enable-flex>
					<div class="m-detail-box">
						<custom-table ref="productTable" view-id="20010" height="grow" readonly>
							<!--关联订单号-->
							<template #order_code="{data}">
								<span v-if="data.order_code">{{data.order_code}}</span>
								<span v-else>-</span>
							</template>
						</custom-table>
					</div>
				</module-tab>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	export default {
		name: 'purchaseOrderDetail',

		props: {
			id: [String, Number]
		},
		
		data() {
			return {
				detailData: {}
			}
		},

		methods: {
			open() {
				this.request({
					url: '/purchase/order/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.detailData = data.detailInfo;
						this.$refs.productTable.init();
						this.$refs.productTable.$refs.list.setData(data.productList);
						this.$refs.dialog.open();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>